import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const LeadPage = lazy(() => import('../../view/pages/LeadPage'));
const LeadDetailPage = lazy(() => import('../../view/pages/LeadDetailPage'));

export const leadRoutes: RouteObject = {
  path: pagePath.lead.list,
  children: [
    {
      index: true,
      element: <LeadPage />,
    },
    {
      path: ':leadId',
      element: <LeadDetailPage />,
    },
  ],
};
